import React from "react";

function IconEnvelope(data) {
  return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={data.w}
        height={data.h}
        viewBox="0 0 100 80"
      >
        <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
          <g transform="translate(0 -10)">
            <path
              stroke="#FF8400"
              strokeWidth="7"
              d="M96 14L50.5 48.0577881 4 14"
            ></path>
            <rect
              width="92"
              height="72"
              x="4"
              y="14"
              stroke="#000"
              strokeWidth="8"
              rx="3"
            ></rect>
          </g>
        </g>
      </svg>
  );
}

export default IconEnvelope;
